// Return config for the current tenant, like layout, type of internships, etc.
export default function useTenantConfig() {
  const { tenant } = useTenant()

  const isMas4you = tenant.value == 'mas4you'
  const isDemo = tenant.value == 'demo'
  const isRaayland = tenant.value == 'raayland'
  const isCasteleijn = tenant.value == 'casteleijn'
  const isNuborgh = tenant.value == 'nuborgh'
  const isCorderius = tenant.value == 'corderius'
  const isMatch2gether = tenant.value == 'match2gether'
  const isMasplein = tenant.value == 'masplein'

  const isWhitelabel = isMasplein || isMas4you || isMatch2gether
  const traineeshipTenants = ['match2gether', 'axia', 'raayland', 'casteleijn', 'nuborgh'] // , 'demo']
  const isTraineeship = traineeshipTenants.includes(tenant.value)
  const isMas = !isTraineeship

  // Define map center type
  type MapCenter = { latitude: number, longitude: number }

  // Default center of Netherlands
  const defaultCenter = { latitude: 52.132633, longitude: 5.291266 }

  // Default map centers by tenant
  const mapCenters: Record<string, MapCenter> = {
    // Add specific tenant centers
    raayland: { latitude: 51.7407, longitude: 5.8732 }, // Venray
    mas4you: { latitude: 52.339915, longitude: 5.686480 }, // In de buurt van Harderwijk
    corderius: { latitude: 52.156113, longitude: 5.387827 }, // Amersfoort
  }

  // Get the default map center for the current tenant
  const defaultMapCenter = mapCenters[tenant.value] || defaultCenter

  return {
    // Is this a demo instance?
    isDemo: isDemo,
    // Is this a mas tenant?
    isMas: isMas,
    // Is this tenant using a whitelabel / custom theme?
    isWhitelabel: isWhitelabel,
    // Is this a traineeship tenant?
    isTraineeship: isTraineeship,
    // It this tenant using hours?
    isUsingHours: isMas,
    // It this tenant using evaluation forms?
    isUsingEvaluationForms: (isMas && !isMas4you) || isDemo || isRaayland || isCasteleijn || isNuborgh,
    // Currently, only Corderius uses the student evaluation form
    isUsingLegacyEvaluationForm: isCorderius,
    // It this tenant using printable paper timesheets?
    isUsingPaperTimesheets: isMas4you,
    // Is using digital contracts
    isUsingDigitalContracts: isTraineeship,
    // Can students submit self-found internships?
    canStudentsSubmitSelfFoundInternships: isMas || !isMatch2gether,
    // Push the QR-code as the primary method to sign contracts for students?
    showQrCodeAsPrimaryMethod: isDemo || isRaayland,
    // Should the company sign first before the student can let others sign?
    companyMustSignFirst: isDemo || isRaayland,
    // Default map center for this tenant
    defaultMapCenter,
    // App name, by default it's "Stageplein" + tenant name
    appName: isWhitelabel ? useCapitalize(tenant.value) : `Stageplein ${useCapitalize(tenant.value)}`,
    // todo: add background color present?
    slogan: isMas ? 'De leukste maatschappelijke stages' : 'Het online stageplein voor al je stages.',
    // Should the logo mark be shown as a placeholder in the search cards?
    showLogoMarkAsPlaceholder: isMas4you,
    // Is the company filling in fields on the contract?
    // TODO: should be removed, see noted in ContractFieldsSubmitted.vue
    isCompanyFillingInContractFields: isTraineeship && !isMatch2gether,
  }
}
